import { Typography } from 'antd';
import React from 'react';
import { RichTextAdvancedRender } from '../../../../../inputs';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem';
import { DivInputStyle } from '../../../../../ui/form/DivInputStyle';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { getWidgetProps } from '../common/util/getWidgetProps';
import { IAsyncValueWidget } from './IAsyncValueWidget';

const { Text } = Typography;

export interface IAsyncValueWidgetPreviewProps
  extends IWidgetComponentProps<IAsyncValueWidget> {}

export function AsyncValueWidgetPreview(props: IAsyncValueWidgetPreviewProps) {
  const { widget } = props;
  const options = getWidgetProps(props);

  return (
    <ConfigFormItem
      name="string"
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={<RichTextAdvancedRender inline text={options.helpText} />}
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
    >
      <DivInputStyle>
        <Text style={{ minHeight: '1.5rem' }} type="secondary">
          {widget.notes}
        </Text>
      </DivInputStyle>
    </ConfigFormItem>
  );
}
